<script lang="ts">
  import { plural } from "../lib/format.js";
  import { router } from "../lib/router.svelte.js";
  import { library, type Piece } from "../lib/stores/library.svelte.js";
  import { playlists } from "../lib/stores/playlists.svelte.js";
  import { ui } from "../lib/stores/ui.svelte.js";
  import Icon from "../components/Icon.svelte";

  function mosaic(ids: string[]): Piece[] {
    return ids
      .map((id) => library.byId.get(id))
      .filter((p): p is Piece => Boolean(p))
      .slice(0, 4);
  }

  async function create(): Promise<void> {
    const id = await playlists.create(`Setlist ${playlists.list.length + 1}`);
    if (id) router.go(`/setlists/${id}`);
  }
</script>

<div class="page" class:narrow={!ui.wide}>
  <header>
    <h1>Setlists</h1>
    <button type="button" class="btn btn-ghost" onclick={create}
      ><Icon name="plus" size={18} /> Neue Setlist</button
    >
  </header>
  <div class="grid">
    {#each playlists.list as playlist, i (playlist.id)}
      <button
        type="button"
        class="tile"
        style:animation-delay="{i * 40}ms"
        onclick={() => router.go(`/setlists/${playlist.id}`)}
      >
        <span class="mosaic" style:background={playlist.accentColor}>
          {#each mosaic(playlist.items) as piece (piece.id)}<img
              src={piece.thumb}
              alt=""
              loading="lazy"
            />{/each}
          {#if playlist.items.length === 0}<span class="icon">{playlist.icon}</span>{/if}
        </span>
        <span class="name ellipsis">{playlist.name}</span>
        <span class="t3 meta">
          {plural(playlist.items.length, "Stück", "Stücke")}
          {#if playlists.activeId === playlist.id}<span class="active">· aktuell</span>{/if}
        </span>
      </button>
    {/each}
  </div>
</div>

<style>
  .page {
    padding: calc(30px + var(--safe-top)) 32px 40px;
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
  .narrow {
    padding: calc(18px + var(--safe-top)) 18px 24px;
  }
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  h1 {
    font-size: 34px;
  }
  .narrow h1 {
    font-size: 28px;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 16px;
  }
  .narrow .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .tile {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    border-radius: var(--r-lg);
    background: var(--surface-2);
    text-align: left;
    animation: rise var(--dur-sheet) var(--ease-out) both;
    transition:
      background var(--dur-base),
      transform var(--dur-base) var(--ease-spring);
  }
  .tile:hover {
    background: #1f1f25;
    transform: translateY(-3px);
  }
  .mosaic {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2px;
    aspect-ratio: 1;
    border-radius: 10px;
    overflow: hidden;
  }
  .mosaic img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    background: var(--paper);
  }
  .icon {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 44px;
  }
  .name {
    font-weight: 800;
    font-size: 15px;
  }
  .meta {
    font-size: 12px;
    font-weight: 600;
    margin-top: -4px;
  }
  .active {
    color: var(--accent);
  }
</style>
